export default __webpack_public_path__ + "static/media/logo-iose-black.3b80bfb8.jpg";